import { Fragment } from 'react'

import { Title } from '../styles'

import { config } from './config'
import { Wrapper, SubTitle, Text } from './styles'

const { process, headerTitle } = config

export function Process() {
  return (
    <Wrapper>
      <Title as="h2">{headerTitle}</Title>
      {process?.map(({ id, title, subtitle }) => (
        <Fragment key={id}>
          <SubTitle as="h3">{title}</SubTitle>
          <Text>{subtitle}</Text>
        </Fragment>
      ))}
    </Wrapper>
  )
}
